<div class="bg-form-background rounded px-5 py-3.5 drop-shadow-lg
    soundShapes:bg-backdrop soundShapes:drop-shadow-none soundShapes:border-secondary soundShapes:border-2 soundShapes:rounded-[.5rem]
    lighthouse:bg-backdrop lighthouse:rounded-[.28571429rem] lighthouse:border-t-2 lighthouse:border-t-primary lighthouse:drop-shadow-none
    lighthouse:border-secondary lighthouse:border">
    <ng-content></ng-content>
</div>
